import * as React from 'react';
import { RouteComponentProps, Link, Prompt } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { StreetAddressViewModel } from '../StreetAddress';
import { fetchApi, JsonResponse } from '../../services/api';
import { JsonForm } from '../Forms/jsonForm';
import Form from 'react-jsonschema-form-bs4';
import Address from '../Forms/fields/address';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    accountId: string
}>;

type State = {
    isLoading: boolean;
    isDirty: boolean;
    account: AccountData|undefined;
    form: JsonForm|undefined;
    errors: Array<{ Message: string, Link: string }>;
}

type AccountData = {
    AccountID: number;
    Active: boolean;
    BillingName: string;
    BillingEmail: string;
    DoorCode: string;
    BillingAddress: StreetAddressViewModel;
    RegistrationToken: string;
}

class Profile extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            isLoading: true,
            isDirty: false,
            account: undefined,
            form: undefined,
            errors: [],
        }

        this.retireAccount = this.retireAccount.bind(this);
        this.reactivateAccount = this.reactivateAccount.bind(this);
        this.openRegistrationForm = this.openRegistrationForm.bind(this);
        this.emailRegistrationForm = this.emailRegistrationForm.bind(this);
        this.updateAccountState = this.updateAccountState.bind(this);
        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.getAccount(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.account && this.state.account.AccountID != accountId) {
            this.getAccount(accountId);
        }
    }

    public render() {
        return <div>
                {this.state.account && <DocumentTitle title={this.state.account.BillingName || "New Profile"} />}
                <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                {this.state.isLoading && <div className="k-loading-image"></div>}
                <br />
                {this.state.errors.map((error, index) => {
                    return <div className="alert alert-danger d-print-none" key={index}>
                        {error.Message}&nbsp;
                        {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                    </div>
                })}
                {this.state.form && <Form
                    showErrorList={false}
                    schema={this.state.form.Schema}
                    uiSchema={this.state.form.UISchema}
                    formData={this.state.account}
                    onChange={(e) => this.updateAccountState(e.formData)}
                    onSubmit={(e) => this.save(e.formData)}
                    fields={{ address: Address }}
                >
                <div className="float-right">
                    {this.state.account.AccountID > 0 && (this.state.account.Active ? <Button type="button" onClick={this.retireAccount} className="btn btn-danger">Retire Account</Button> : <Button type="button" onClick={this.reactivateAccount} className="btn btn-success">Reactivate Account</Button>)}
                    &nbsp;&nbsp;
                    {this.state.account.RegistrationToken && this.state.account.Active && <Button type="button" onClick={this.openRegistrationForm}>Add Child</Button>}
                    &nbsp;&nbsp;
                    {this.state.account.AccountID > 0 && this.state.account.Active && <Button type="button" onClick={this.emailRegistrationForm}>Email Registration Form</Button>}
                    &nbsp;&nbsp;
                    <LoadingButton
                        type="submit"
                        disabled={!this.state.isDirty}
                        isLoading={this.state.isLoading}
                        isLoadingText="Saving..."
                        className="btn btn-primary"
                    >
                        {this.state.account.AccountID === 0 ? 'Create' : 'Save'}
                    </LoadingButton>
                </div>
            </Form>}
        </div>
    }

    private save(data: AccountData) {
        if (this.state.account) {
            this.setState({ isLoading: true });
            if (this.state.account.AccountID > 0) {
                fetchApi(`api/Account/Save/${this.state.account.AccountID}`, data, 'POST')
                    .then((response: {
                        Errors: Array<any>, // MVC Errors
                        ErrorMessages: Array<{ Message: string, Link: string }> // Our Errors
                    }) => {
                        this.setState({ errors: response.ErrorMessages || [] });
                        if (!response.Errors && !response.ErrorMessages)
                        {
                            this.setState({ isDirty: false });
                        }
                    })
                    .finally(() => {
                        this.setState({ isLoading: false });
                    });
            } else {
                fetchApi(`api/Account/Create/`, data, 'POST')
                    .then((response: {
                        AccountID: number,
                        RegistrationToken: string,
                        Errors: Array<any>, // MVC Errors
                        ErrorMessages: Array<{ Message: string, Link: string }> // Our Errors
                    }) => {
                        this.setState({ errors: response.ErrorMessages || [] });
                        if (!response.Errors && !response.ErrorMessages)
                        {
                            this.updateAccountState({ AccountID: response.AccountID, RegistrationToken: response.RegistrationToken });
                            this.setState({ isDirty: false });

                            this.props.history.push("/accounts");
                        }
                    })
                    .finally(() => {
                        this.setState({ isLoading: false });
                    });
            }
        }
    }

    private updateAccountState(value: Partial<AccountData>) {
        const account = Object.assign({}, this.state.account, value);
        this.setState({ account, isDirty: true });
    }

    private getAccount(accountId: number) {
        fetchApi(`api/Account/Get/${accountId}`)
            .then((response: { Account: AccountData, Form: JsonForm }) => {
                response.Form.Schema = JSON.parse(response.Form.Schema);
                response.Form.UISchema = JSON.parse(response.Form.UISchema);
                this.setState({ account: response.Account, form: response.Form, isDirty: false });
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    private emailRegistrationForm() {
        if (this.state.account) {
            fetchApi(`api/Account/SendRegistrationForm/${this.state.account.AccountID}`, {}, 'POST')
                .then(() => alert('Success! Registration Form Sent.'));
        }
    }

    private openRegistrationForm() {
        if (this.state.account) {
            window.open(`/registration/${this.state.account.AccountID}/${this.state.account.RegistrationToken}`, '_blank');
        }
    }

    private retireAccount() {
        if (this.state.account && confirm("Retire Account?")) {
            fetchApi(`api/Account/RetireAccount/${this.state.account.AccountID}`, this.state.account.Active, 'POST')
                .then((response: JsonResponse) => {
                    if (response.Success) {
                        this.updateAccountState({ Active: false });
                        this.setState({ errors: [] });
                    } else {
                        this.setState({ errors: [{ Message: response.ErrorMessage, Link: null }] });
                    }
                })
                .catch(() => {
                    alert("Unknown Error Occurred!");
                });
        }
    }

    private reactivateAccount() {
        if (this.state.account) {
            fetchApi(`api/Account/ReactivateAccount/${this.state.account.AccountID}`, this.state.account.Active, 'POST')
                .then((response: {
                    ErrorMessages: Array<{ Message: string, Link: string }> // Our Errors
                }) => {
                    this.setState({ errors: response.ErrorMessages || [] });
                    if (!response.ErrorMessages)
                    {
                        this.updateAccountState({ Active: true });
                    }
                });
        }
    }
}

export default Profile;
